import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import './styles/index.css';  // Correct path to './styles/index.css'
import 'bootstrap/dist/css/bootstrap.min.css';
// Optional for JS components (dropdowns, modals, etc.)
// import 'bootstrap/dist/js/bootstrap.bundle.min';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
